import React from 'react';
import AdminUserDetailsView from './AdminUserDetailsView';
import AdminUserDetailsLogic from './AdminUserDetailsLogic';
import { useParams, useNavigate } from 'react-router-dom';
import { PageTitle } from '../';

export default function AdminUserDetailsPage() {
  const { userId } = useParams();
  const navigate = useNavigate();

  const {
    user,
    applications,
    selectedApplication,
    loading,
    applicationsLoading,
    isUpdatingStatus,
    handleApplicationSelect,
    handleBackToSettings,
    handleDeleteUser,
    handleResetPassword,
    handleUpdateAppStatus
  } = AdminUserDetailsLogic(userId, navigate);

  return (
    <>
      <PageTitle title={user ? `User: ${user.displayName || user.email}` : 'User Details'} />
      <AdminUserDetailsView
        user={user}
        applications={applications}
        selectedApplication={selectedApplication}
        loading={loading}
        applicationsLoading={applicationsLoading}
        isUpdatingStatus={isUpdatingStatus}
        onApplicationSelect={handleApplicationSelect}
        onBackToSettings={handleBackToSettings}
        onDeleteUser={handleDeleteUser}
        onResetPassword={handleResetPassword}
        onUpdateAppStatus={handleUpdateAppStatus}
      />
    </>
  );
} 